'use strict';

import React from 'react';

require('styles//AppItem.css');

class AppItemComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state={isVisible:false};
  }
  handleClick(e) {
    e.preventDefault();
    this.setState(prevState => ({
      isVisible: !prevState.isVisible
    }));
  }
  render() {
    return (
      <li className="appitem-component">
        <img src={this.props.img} alt=""/>
        <div className="appHeader" onClick={this.handleClick}>
         {this.props.header}
        </div>
        {this.props.url?<div class="link"><a href={this.props.url}>Вход</a></div>:''}
        {
          this.state.isVisible && <div>{this.props.content}</div>
        }
      </li>
    );
  }
}

AppItemComponent.displayName = 'AppItemComponent';

// Uncomment properties you need
//AppItemComponent.propTypes = {img:Image, header:String, content:String};
// AppItemComponent.defaultProps = {};

export default AppItemComponent;



// WEBPACK FOOTER //
// ./src/components/AppItemComponent.js